import BaseDialog from "../../modelDialogs/BaseDialog";
import Fuse from "../../models/Fuse";
import { useState } from "react";
import { showToast } from "../Toasts";
import ELCB from "../../models/ELCB";
import Cabinet from "../../models/Cabinet";
import { itx } from "../../translationItx/itx";

export default function FusePlacementDialog(props: { fuse: Fuse; targetFuse: Fuse }) {
  const { fuse: dragedFuse, targetFuse: onDropedFuse } = props;

  const [placement, setPlacement] = useState<
    | "before" // no itx
    | "after" // no itx
    | null
  >(null);

  function handlePlacement(position: "before" | "after" | null): boolean {
    if (position === null) {
      showToast({ text: itx("FusePlacementDialog.bitteWhlenSie", "Bitte wählen Sie eine Platzierung aus.") });
      return false;
    }
    // check first if fuse and targetFuse have the same parent
    // if they dont have the same parent, the parent of the fuse has to me changed
    const dragedFuseParent = dragedFuse.parent;
    const newParent = onDropedFuse.parent;
    if (dragedFuseParent !== newParent && newParent) {
      dragedFuse.parent = newParent;
      if (dragedFuseParent?.className == "ELCB") {
        (dragedFuseParent as ELCB).fuses.remove(dragedFuse);
      } else {
        // has to be cabinet
        (dragedFuseParent as Cabinet).fi_ls_s.remove(dragedFuse);
      }
      dragedFuseParent?.raiseOnChange("childCollection");
      if (newParent?.className == "ELCB") {
        (newParent as ELCB).fuses.add(dragedFuse);
      } else {
        // has to be cabinet
        (newParent as Cabinet).fi_ls_s.add(dragedFuse);
      }
      newParent?.raiseOnChange("childCollection");
    }

    //now change the place and renumber bouth parent fuse collections
    const orderToRenumber = new Array<Fuse>();
    if (dragedFuseParent?.className == "ELCB") {
      (dragedFuseParent as ELCB).renumber();
    } else if (dragedFuseParent?.className == "Cabinet") {
      // do nothing
    }

    if (newParent?.className == "ELCB") {
      // handle her bevore and after
      for (const fuse of (newParent as ELCB).fuses.sortBy("tag")) {
        if (fuse == onDropedFuse && placement == "before") {
          orderToRenumber.push(dragedFuse);
        }
        if (fuse != dragedFuse) {
          orderToRenumber.push(fuse);
        }
        if (fuse == onDropedFuse && placement == "after") {
          orderToRenumber.push(dragedFuse);
        }
      }
    } else if (newParent?.className == "Cabinet") {
      for (const fuse of (newParent as Cabinet).fi_ls_s.sortBy("tag")) {
        if (fuse == onDropedFuse && placement == "before") {
          orderToRenumber.push(dragedFuse);
        }
        if (fuse != dragedFuse) {
          orderToRenumber.push(fuse);
        }
        if (fuse == onDropedFuse && placement == "after") {
          orderToRenumber.push(dragedFuse);
        }
      }
    }

    if (dragedFuse.is_FI_LS) {
      state.nameAndTagManager.renumberTagObjs(orderToRenumber, state.settings.devicePrefix.fuse);
    } else {
      const affectedElcbs = new Set<ELCB>();
      if (dragedFuseParent?.className === "ELCB") affectedElcbs.add(dragedFuseParent as ELCB);
      if (newParent?.className === "ELCB") affectedElcbs.add(newParent as ELCB);
      if (state.settings.fuseTagSchema === "A" || state.settings.fuseTagSchema === "C") {
        state.nameAndTagManager.renumberFuseTags();
      } else {
        affectedElcbs.forEach((elcb) => {
          const orderedFuses = elcb === newParent ? orderToRenumber : undefined;
          state.nameAndTagManager.renumberFuseTags(elcb, orderedFuses);
        });
      }
    }

    // place the fuse relative to the target fuse based on the selected position
    return true;
  }

  return (
    <BaseDialog
      title={itx("FusePlacementDialog.sicherungPlatzieren", "Sicherung platzieren")}
      okCaption={itx("FusePlacementDialog.platzieren", "Platzieren")}
      enterAsOk={false}
      onClose={() => true}
      onOk={() => {
        return handlePlacement(placement);
      }}
    >
      <div style={{ padding: "16px", minWidth: "420px" }}>
        <div
          style={{
            color: "var(--text-color)",
            marginBottom: "16px",
            lineHeight: 1.5,
          }}
        >
          {itx("FusePlacementDialog.woSollDie", "Wo soll die Sicherung")}{" "}
          <strong>
            "{dragedFuse.tag} {dragedFuse.name}"
          </strong>{" "}
          {itx("FusePlacementDialog.relativZu", "relativ zu")}{" "}
          <strong>
            "{onDropedFuse.tag} {onDropedFuse.name}"
          </strong>{" "}
          {itx("FusePlacementDialog.platziertWerden", "platziert werden?")}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {/* VORHER */}
          <button
            type="button"
            className="button"
            onClick={() => setPlacement("before")}
            style={{
              width: "100%",
              boxSizing: "border-box",

              display: "flex",
              alignItems: "flex-start",

              gap: "14px",
              padding: "12px 16px",

              textAlign: "left",
              whiteSpace: "normal",

              // Wichtig bei globalen Button-Styles
              height: "auto",
              minHeight: "0",
              lineHeight: "normal",

              borderRadius: "var(--panel-border-radius)",
            }}
          >
            <i
              className="las la-arrow-up"
              style={{
                fontSize: "1.6em",
                color: "var(--primary-color)",
                flexShrink: 0,
                lineHeight: 1,
                marginTop: "2px",
              }}
            />

            <div
              style={{
                minWidth: 0,
                flex: 1,
                lineHeight: 1.4,
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  lineHeight: 1.3,
                  marginBottom: "3px",
                }}
              >
                {itx("FusePlacementDialog.vorher", "Vorher")}
              </div>

              <div
                style={{
                  color: "grey",
                  fontSize: "0.85em",
                  lineHeight: 1.4,
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                "{dragedFuse.tag} {dragedFuse.name}"{itx("FusePlacementDialog.wirdVor", " wird vor ")}"
                {onDropedFuse.tag} {onDropedFuse.name}"{itx("FusePlacementDialog.platziert", " platziert.")}
              </div>
            </div>
          </button>

          {/* NACHHER */}
          <button
            type="button"
            className="button"
            onClick={() => setPlacement("after")}
            style={{
              width: "100%",
              boxSizing: "border-box",

              display: "flex",
              alignItems: "flex-start",

              gap: "14px",
              padding: "12px 16px",

              textAlign: "left",
              whiteSpace: "normal",

              // Wichtig bei globalen Button-Styles
              height: "auto",
              minHeight: "0",
              lineHeight: "normal",

              borderRadius: "var(--panel-border-radius)",
            }}
          >
            <i
              className="las la-arrow-down"
              style={{
                fontSize: "1.6em",
                color: "var(--primary-color)",
                flexShrink: 0,
                lineHeight: 1,
                marginTop: "2px",
              }}
            />

            <div
              style={{
                minWidth: 0,
                flex: 1,
                lineHeight: 1.4,
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  lineHeight: 1.3,
                  marginBottom: "3px",
                }}
              >
                {itx("FusePlacementDialog.nachher", "Nachher")}
              </div>

              <div
                style={{
                  color: "grey",
                  fontSize: "0.85em",
                  lineHeight: 1.4,
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                "{dragedFuse.tag} {dragedFuse.name}"{itx("FusePlacementDialog.wirdNach", " wird nach ")}"
                {onDropedFuse.tag} {onDropedFuse.name}"{itx("FusePlacementDialog.platziert", " platziert.")}
              </div>
            </div>
          </button>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            background: "var(--panel-background)",
            borderRadius: "var(--panel-border-radius)",
            boxShadow: "var(--panel-shadow)",
            padding: "12px 16px",
            marginTop: "18px",
          }}
        >
          <i
            className="las la-info-circle"
            style={{
              fontSize: "1.5em",
              color: "var(--primary-color)",
              flexShrink: 0,
              lineHeight: 1,
            }}
          />

          <div
            style={{
              color: "grey",
              fontSize: "0.85em",
              lineHeight: 1.45,
              minWidth: 0,
            }}
          >
            <div
              style={{
                fontWeight: 600,
                color: "var(--text-color)",
                marginBottom: "3px",
              }}
            >
              {itx("FusePlacementDialog.hinweisZurReihenfolge", "Hinweis zur Reihenfolge")}
            </div>
            {itx(
              "FusePlacementDialog.durchDasPlatzieren",
              "Durch das Platzieren können sich die Tags bzw. Positionen der anderen Sicherungen entsprechend anpassen.",
            )}
          </div>
        </div>

        <div
          style={{
            color: "grey",
            fontSize: "0.85em",
            marginTop: "14px",
          }}
        >
          {itx(
            "FusePlacementDialog.whlenSieAus",
            "Wählen Sie aus, ob die Sicherung vor oder nach der Zielsicherung eingefügt werden soll.",
          )}
        </div>
      </div>
    </BaseDialog>
  );
}
